export const COLORS = {
  navy: '#0a1628',
  navySoft: '#1e3a5f',
  slate: '#4a6080',
  silver: '#b8c2cf',
  silverLight: '#e4e8ee',
  silverDark: '#8a94a3',
  bg: '#f4f6f9',
  positive: '#4c9a72',
  negative: '#c1594f',
};

// Consistent per-entity accent used across Portfolio and Dashboard.
export const ENTITY_COLORS = {
  Consolidated: COLORS.navy,
  FJC: '#3d6199',
  FJH: COLORS.silverDark,
};

// Navy-to-silver ramp for chart series (pie slices, etc.).
export const RAMP_COLORS = ['#0a1628', '#1b2f4d', '#2c4872', '#3d6199', '#5b7fae', '#8098bd', '#a8bccd'];
